import { useQuery } from '@tanstack/react-query';
import { fetchFundCommitments } from '../../api/finance/fundCommitments';

export const useFundCommitments = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['fundCommitments', filters],
    queryFn: () => fetchFundCommitments(filters),
    keepPreviousData: true,
    enabled: options.enabled,
  });

  return {
    ...query,
    data: query.data?.data?.fundCommitments ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.pageSize ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export default useFundCommitments;
